export enum POST_STATUS {
  SENT = "SENT",
  SCHEDULED = "SCHEDULED"
}
